import React, { Component} from "react";
import CaptchaDotNet from "./CaptchaDotNet";


export default class LoginModule extends Component {
  
  constructor(props) {
    super(props);
    this.email = '';
    this.password = '';
    this.captchaSecret = '';
    this.loginRequested = false;
    this.nextCaptcha = 0;
    this.state = {
      captchaSeed : 0,
      emailFieldValid : true,
      passwordFieldValid : true,
      captchaSecretPopulated : true,
      errorMessage : '',
    };
  }

  incrementCaptchaSeed() {
    let newSeed = this.state.captchaSeed + 1;
    this.setState({captchaSeed: newSeed});
  }

  submitLogin () {
    if (this.loginRequested || !this.state.emailFieldValid || !this.state.passwordFieldValid || !this.state.captchaSecretPopulated) {
      return;
    }

    const serverCaptchaString = document.getElementById('inCaptchaString').value;
    if (serverCaptchaString === undefined) {
      this.setState({'errorMessage':"Captcha unavailable, try again later"});
      return;
    }
    
    this.loginRequested = true;
    fetch('https://cwcreations.net/php/cwblackjackacc/login.php', {
      method: 'POST',
      body: JSON.stringify({
        email_address : this.email,
        password : this.password,
        captcha_password : this.captchaSecret,
        captcha_string : serverCaptchaString}),
    }).then((res) => res.json())
    .then((data) => {
      this.loginRequested = false;
      if (data.code === -1) {
        this.setState({errorMessage:'*** Invalid username or password'});
      } else if (data.code === -2) {
        this.setState({errorMessage:'*** Wrong captcha answer',captchaSecretPopulated : false});
      } else if (data.code === -3) {
        this.setState({errorMessage:'*** Captcha expired, try again',captchaSecretPopulated : false});
      } else if (data.code === -4) {
        this.setState({errorMessage:'*** Login server not available',captchaSecretPopulated : false});
      }

      if (data.code === 0) {
        this.props.reportResult(data);
      } else {
        this.incrementCaptchaSeed();
      }
    });
  }

  getEmailFieldStyle() {
    return this.state.emailFieldValid? {'border':'5px solid #97c2d0'} : {'border': '5px solid #fba5a5'};
  }

  getPasswordFieldStyle() {
    return this.state.passwordFieldValid? {'border':'5px solid #97c2d0'} : {'border': '5px solid #fba5a5'};
  }

  getSecretFieldStyle(){
    return this.state.captchaSecretPopulated? {'border':'5px solid #97c2d0'} : {'border': '5px solid #fba5a5'};
  }

  validateEmail() {
    let res = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
    this.setState({emailFieldValid : res.test(this.email)});
  }

  handleEmailChange(e) {
    let validity = false;
    if (e.target.value.length > 0) {
      validity = true;
    }
    if (validity !== this.state.emailFieldValid) {
      this.setState({emailFieldValid : validity});
    }
    this.email = e.target.value;
  }
  handlePasswordChange(e) {
    let validity = false;
    if (e.target.value.length >= 6) {
      validity = true;
    } 
    if (validity !== this.state.passwordFieldValid) {
      this.setState({passwordFieldValid : validity});
    }
    this.password = e.target.value;
  }
  handleSecretChange(e) {
    let populated = false;
    if (e.target.value.length > 0) {
      populated = true;
    } 
    if (populated !== this.state.captchaSecretPopulated) {
      this.setState({captchaSecretPopulated : populated});
    }
    this.captchaSecret = e.target.value;
  }
  getErrorMessage() {
    return this.state.errorMessage;
  }
  render(props) {
    const emailFStyle = this.getEmailFieldStyle();
    const passwordFieldStyle = this.getPasswordFieldStyle();
    const captchaFeildStyle = this.getSecretFieldStyle();
    
    return (<div id='loginModule'>
                <div style={{'display':'flex','flexDirection':'column','alignItems':'start'}}>
                  <p style={{'margin':'15px','color':'#db0001'}}>{this.getErrorMessage()}</p><p>Email Address:</p><input className='inputField' id='inEmail' style={emailFStyle} onBlur={this.validateEmail.bind(this)} type='text' size='28' maxLength='45' onChange={this.handleEmailChange.bind(this)}/>
                  <p>Password:</p><input className='inputField' id='inPassword' style={passwordFieldStyle} size='28' maxLength='30' onBlur={this.handlePasswordChange.bind(this)} onChange={this.handlePasswordChange.bind(this)} type='password'/>
                  </div>
                <div style={{'display':'flex','marginTop':'30px','columnGap':'80px'}}><CaptchaDotNet key={this.state.captchaSeed}/><div><input style={captchaFeildStyle}className='inputField' id='inSecret' maxLength='6' size='8' type='text' onChange={this.handleSecretChange.bind(this)}/><p>Captcha Answer</p><button  onClick={this.submitLogin.bind(this)}>Login</button></div></div>
            </div>);
  }
}